import { useEffect, useState, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import DeepSociety from "@/components/DeepSociety";
import Moments from "@/components/Moments";
import MenuSection from "@/components/MenuSection";
import Events from "@/components/Events";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import ShopTeaser from "@/components/ShopTeaser";
import Reservation from "@/components/Reservation";
import Footer from "@/components/Footer";
import ShopPage from "@/components/ShopPage";
import ShopSuccess from "@/components/ShopSuccess";
import ShopCancel from "@/components/ShopCancel";
import EventsPage from "@/components/EventsPage";

const LangContext = createContext({ lang: "it", setLang: () => {} });
export const useLang = () => useContext(LangContext);

const Landing = () => (
    <div className="App bg-noir min-h-screen">
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <About />
            <DeepSociety />
            <Moments />
            <MenuSection />
            <Events />
            <Gallery />
            <Reviews />
            <ShopTeaser />
            <Reservation />
        </main>
        <Footer />
    </div>
);

function App() {
    const [lang, setLang] = useState("it");

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <LangContext.Provider value={{ lang, setLang }}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/eventi" element={<EventsPage />} />
                    <Route path="/shop/success" element={<ShopSuccess />} />
                    <Route path="/shop/cancel" element={<ShopCancel />} />
                </Routes>
                <Toaster theme="dark" position="bottom-right" />
            </BrowserRouter>
        </LangContext.Provider>
    );
}

export default App;
